import Const from 'constants';
import {BaseAction} from 'actions';

let SinglegameForcedStacking = {
    useStacking(use) {
        return {
            type: Const.SINGLEGAME_FORCED_STACKING_IS_USED,
            use,
        };
    },

    setCombinationIsChecked(comboKey, checked) {
        return {
            type: Const.SINGLEGAME_FORCED_STACKING_SET_COMBO_IS_CHECKED,
            comboKey,
            checked,
        };
    },

    setCombinationExposure(comboKey, exposure) {
        return {
            type: Const.SINGLEGAME_FORCED_STACKING_SET_COMBO_EXPOSURE,
            comboKey,
            exposure,
        };
    },
};

export default {...BaseAction, ...SinglegameForcedStacking};
